export default __webpack_public_path__ + "173dc0fbf5c4ad00cdd39c90264cfc7f.svg";